import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createUserAdmin } from 'reducers/adminUsersReducer';
// import { closeModal } from 'reducers/modalReducer';
import { isValidEmail } from 'utils/validators';
import StandardModal from 'modals/StandardModal';
import Spinner from 'components/Spinner';
import Alert from 'view/components/Alert';

const UserAdminCreateModal = ({ options }) => {
	const dispatch = useDispatch();
	const { isLoading, isUpdating } = useSelector((state) => ({
		isLoading: state.adminUsers.isLoadingUser,
		isUpdating: state.adminUsers.isUpdating,
	}));

	const [email, setEmail] = useState('');
	const [name, setName] = useState('');
	const [phone, setPhone] = useState('');
	const [isEmailValid, setIsEmailValid] = useState('');
	const [isSuccess, setIsSuccess] = useState(false);

	const onChangeEmail = (emailString) => {
		setEmail(emailString);
		setIsEmailValid(isValidEmail(emailString));
	};

	//todo: notify on success and reload users data
	const onSubmit = () => {
		setIsSuccess(false);
		dispatch(
			createUserAdmin({
				name,
				email,
				phone,
			}),
		).then((res) => {
			if (res?.type === 'CREATE_ADMIN_USER_SUCCESS') {
				setIsSuccess(true);
			}
		});
	};

	const userForm = (
		<div>
			<div className="form-group mb-3">
				<label>Name</label>
				<input
					type="text"
					className="form-control"
					value={name}
					onChange={(ev) => setName(ev.target.value)}
					placeholder="Name"
				/>
			</div>
			<div className="form-group mb-3">
				<label>Email</label>
				<input
					type="email"
					placeholder="Email"
					className={`form-control email-input ${
						isEmailValid ? 'valid' : 'invalid'
					}`}
					required
					value={email}
					onChange={(ev) => onChangeEmail(ev.target.value)}
					autoFocus
				/>
			</div>
			<div className="form-group mb-3">
				<label>Phone Number</label>
				<input
					type="text"
					className="form-control"
					value={phone}
					onChange={(ev) => setPhone(ev.target.value)}
					placeholder="(555)-555-5555"
				/>
			</div>
		</div>
	);

	const successAlert = (
		<Alert color="success">
			<div>Invitation sent!</div>
		</Alert>
	);

	return (
		<StandardModal
			title={'Invite User'}
			size="md"
			closeOnOutsideClick
			confirmText="Send Invite"
			closeLabel="Cancel"
			onConfirm={onSubmit}
			disableConfirm={!email || !isEmailValid || isUpdating || isLoading}
			disableClose={isUpdating}
		>
			<div>
				{isSuccess && successAlert}
				{isLoading || isUpdating ? (
					<Spinner />
				) : (
					<div className="">{userForm}</div>
				)}
			</div>
		</StandardModal>
	);
};

export default UserAdminCreateModal;
